import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=0c83cbbe&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c83cbbe')) {
      api.createRecord('0c83cbbe', component.options)
    } else {
      api.reload('0c83cbbe', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=0c83cbbe&", function () {
      api.rerender('0c83cbbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-84M1dJx5PSa0X/JS/comp/ErrorMessage.vue"
export default component.exports